export default [
    {name:"员工",id:"1",value:"1864"}
    ,{name:"外部客户",id:"2",value:"925"},
]


// WEBPACK FOOTER //
// ./src/configure/http/mock/response/index/loadSFZBData.js